import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function WelcomeMessage(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };
  return (
    <Accordion.Item
      eventKey="welcome-message"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>Welcome Message</Accordion.Title>
        <Accordion.SubTitle>
          Set the message displayed to greet visitors
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Title</div>
          <TextInput
            value={workingLanguageConfig.startTitle}
            setValue={(value) => updateLanguageConfig({ startTitle: value })}
            showEmojiButton={false}
            maxWordCount={25}
          />
          <div className="text-sm font-medium mb-2">Sub Title Row 1</div>
          <TextInput
            value={workingLanguageConfig.startSubtitle1}
            setValue={(value) =>
              updateLanguageConfig({ startSubtitle1: value })
            }
            showEmojiButton={false}
            maxWordCount={60}
          />
          <div className="text-sm font-medium mb-2">Sub Title Row 2</div>
          <TextInput
            value={workingLanguageConfig.startSubtitle2}
            setValue={(value) =>
              updateLanguageConfig({ startSubtitle2: value })
            }
            showEmojiButton={false}
            maxWordCount={60}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
